/* eslint-disable no-restricted-imports */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useMemo} from "react";
import {Link, useNavigate} from "react-router-dom";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {useSelector} from "react-redux";
import objectPath from "object-path";
import {useHtmlClassService} from "../../_core/MetronicLayout";
import {UserProfileDropdown} from "./dropdowns/UserProfileDropdown";

export function QuickUserToggler() {
  const navigate = useNavigate();
  const {user} = useSelector(state => state.auth);
  const userobject = user?.userData || user;
  const username = userobject?.name || "";
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      offcanvas: objectPath.get(uiService.config, "extras.user.layout") === "offcanvas",
    };
  }, [uiService]);

  return (<>
        {layoutProps.offcanvas && (
            <div className="topbar-item d-flex align-items-center">
              <OverlayTrigger
                placement="bottom"
                trigger={["hover", "focus"]}
                overlay={<Tooltip id="quick-user-tooltip">User Profile</Tooltip>}
              >
                <Link
                  to="/user-profile"
                  className="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
                >
                  <span className="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">Hi,</span>
                  <span className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
                    {username}
                  </span>
                </Link>
              </OverlayTrigger>
              <button
                type="button"
                className="btn btn-sm btn-light-danger btn-hover-danger ml-1"
                onClick={() => navigate("/logout")}
              >
                Logout
              </button>
            </div>
        )}

        {!layoutProps.offcanvas && (<UserProfileDropdown/>)}
      </>
  );
}
